import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  company: "O'Lime Design",
  founder: "Marie Mazzone",
  siret: "",
  ape: "7410Z",
  vat: "TVA non applicable, article 293 B du CGI",
  email: "",
  phone: "",
  whatsapp: "",
  city: "Rueil-Malmaison, France",
  host_name: "OVHcloud",
  host_address: "2 rue Kellermann, 59100 Roubaix, France",
  instagram: "",
  pinterest: "",
  linkedin: "",
  calendly_url: "",
};

const SiteConfigContext = createContext({ config: DEFAULTS, refresh: () => {} });

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULTS);

  const refresh = async () => {
    try {
      const { data } = await api.get("/site-config");
      setConfig({ ...DEFAULTS, ...data });
    } catch (e) {
      // keep defaults
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SiteConfigContext.Provider value={{ config, refresh }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
